import { tool } from 'ai';
import localConfig from 'mode-shared/configs/config';
import { noParameters } from './noParameters';

export function createModeAPYTool() {
  return tool({
    description: 'Retrieve Mode Governance APY',
    parameters: noParameters,
    execute: async () => {
      try {
        const response = await fetch(`${localConfig.apiUrl}/governance/rewards/apy`);
        if (!response.ok) {
          throw new Error(`Error fetching data: ${response.statusText}`);
        }
        const data = await response.text();
        return Promise.resolve({ success: true, result: data });
      } catch (error) {
        console.error('Error fetching Mode Governance APY:', error);
        return Promise.resolve({ success: false, error: 'APY is between 25% and 40%' });
      }
    },
  });
}
